<template>
	<div class="pos-relative">
		<div class="footer-wrap">
			<h2>您的企业账号已提交了超过{{count}}个待报价的SKU，授权ERP账号后可以查看所有商品报价情况</h2>
	    	<div>
	    		<button class="btn mg-r-30 btn-primary" :disabled="!autoSubmit" @click="auth()">立即授权ERP账号</button>
	    		<div class="chk-group">
		          <label>
		            <span>
		              <input
		                type="checkbox"
		                v-model="autoSubmit"
		              >
		            </span>
		          </label>
		                           授权启用本系统，表示您已阅读并同意
		                           <a href="javascript:;" class="tx-info" @click="openModal">用户协议</a>
		        </div>
	    		
	    	</div>
		</div>
	</div>
	
</template>

<script>
export default {
  props: ["count"],
  data(){
    return {
    	autoSubmit: true,
    }
  },
  methods: {
  	auth(){
  		this.$emit("auth");
  	},
  	openModal(){
  		this.$emit("openModal");
  	}
  }
}
</script>

<style>
.pos-relative{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0;
    border-top: 1px solid #17a2b8;
    min-width: 39.375rem;
    box-shadow: 1px 0 12px rgba(255,255,255,0.6);
    background-image: linear-gradient(to top, #e1e7ed 60%, rgba(255,255,255,0.6) 100%);
    /*background-image: linear-gradient(to top, rgba(204,204,204,1) 50%, rgba(204,204,204,0.6) 100%);*/
    z-index: 2;
    text-align: center;
}
.footer-wrap>h2{
	font-size: 18px;
	margin: 3rem 0 0;
}
.footer-wrap>div{
	font-size: 14px;
    color: #000;
    padding-bottom: 3rem;
    /*background: -webkit-linear-gradient(rgba(255,255,255,0.6),rgba(255,255,255,1));*/
}
.footer-wrap>div>button{
	margin: 2rem auto;
}
.footer-wrap>div>button[disabled]{
	opacity: 0.5;
}
.tx-info{
	color: #17a2b8;
	text-decoration: underline;
}
</style>